module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/volume-half-649bef2fc2e3ad5dd14a42e77da92aea.svg";